import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles';

const useStyles = makeStyles(styles);

export const Links = ({ links }) => {
  const classes = useStyles();
  return (
    links &&
    links?.length > 0 &&
    links?.map(item => (
      <Grid key={`down-bar-link-${item?.name}`} item>
        {item?.external ? (
          <a
            href={item?.url}
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item?.name}
          </a>
        ) : (
          <Typography
            component={Link}
            to={item?.url}
            variant="body1"
            className={classes.link}
          >
            {item?.name}
          </Typography>
        )}
      </Grid>
    ))
  );
};
